import { mixins } from '@mindtickle/styles/lib';
import styled from 'styled-components';

export const StyledAdminShellLayout = styled.div`
  height: 100vh;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;

  /* Reason for using min-width - https://leonardofaria.net/2020/07/18/using-flexbox-and-text-ellipsis-together */
  min-width: 0;
  display: flex;
  position: relative;
  flex-direction: column;

  .shell-layout-admin-content {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    position: relative;

    .shell-layout-admin-content-wrapper {
      flex: 1;
      height: 100%;
      min-width: 0;
      min-height: 0;
      display: flex;
      position: relative;
    }
  }
`;

export const StyledBerryWidget = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  z-index: ${mixins.zIndex.POPOVER};
`;
